import { createGlobalStyle } from "styled-components";
import { designTokens } from "./styles/design-tokens";
import ShowcardGothicFont from "./assets/fonts/ShowcardGothic.ttf";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Showcard Gothic';
    src: url(${ShowcardGothicFont}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  ${designTokens}

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    font-family: var(--font-body);
    background: var(--bg-page);
    color: var(--navy);
    min-height: 100vh;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: var(--gray-100);
  }
  ::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: 3px;
  }

  /* Isolamento do bracket: restaura ambiente original (Inter, content-box) */
  .container-geral-bracket {
    font-family: 'Inter', sans-serif !important;
    color: #000;
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .container-geral-bracket *,
  .container-geral-bracket *::before,
  .container-geral-bracket *::after {
    font-family: 'Inter', sans-serif !important;
    color: inherit;
    box-sizing: content-box;
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }
`;
